/* eslint-style-disable */
import '../vendor/slick.min';

export default {
    init() {
      $('.js-popproducts').slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        }, {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
    });

    $('.js-popproducts').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });


    $('.js-gallery').slick({
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        centerPadding: '0px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 769,
                settings: {
                    arrows: true,
                },
        }],
    });


    $('.js-gallery').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });

    $('.js-product-gallery').slick({
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        infinite: true,
    });

    $('.js-features').slick({
        infinite: false,
    });
    $('.js-features').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });

    $('.js-horizslider').slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },{
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },{
            breakpoint: 569,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
    });
    $('.js-horizslider').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });

    $('.js-slick-benefits').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        slide: '.mainheader__benefits__benefit',
    })

    const benefitsInit = () => {
        var viewportWidth = $(window).width();

        if (viewportWidth > 768) {
            $('.js-slick-benefits.slick-initialized').slick('unslick');
        } else {
            $('.js-slick-benefits').not('.slick-initialized').slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2000,
                fade: true,
            })
        }
    }

    benefitsInit();

    $(window).on('resize', function() {
        benefitsInit();
    });

    $('.js-upcomingslider').slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            }, {
            breakpoint: 650,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
    });
    $('.js-upcomingslider').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });

    $('.js-usp-bar__columns').slick({
        infinite: false,
        arrows: false,
        slidesToShow: 1.52,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 400,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                },
            }, {
            breakpoint: 550,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                },
            }, {
            breakpoint: 769,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                },
            },
            {
            breakpoint: 1025,
            settings: 'unslick',
            // settings: {
            //     slidesToShow: 5,
            //     slidesToScroll: 1,
            // },
        }],
    });
    $('.js-usp-bar__columns').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });

    $(window).on('resize', function() {
        $('.js-usp-bar__columns').slick('resize');
    });

    $('.js-text-media-carousel').slick({
        infinite: true,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        speed: 500,
        adaptiveHeight: true,

    });
    $('.js-text-media-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(slick.$slides[nextSlide]).addClass('slick-slide-next');
    });
    $('.js-text-media-carousel').on('afterChange', function(event, slick, currentSlide){
        $(slick.$slides[currentSlide]).removeClass('slick-slide-next');
        $(document).trigger('lazyrefresh');
    });

    let isChanging = false;
    $('.js-h1-testimonials-carousel').on('init breakpoint', function(event, slick){
        if ( ! isChanging ) {
            isChanging = true;
            if ( slick.activeBreakpoint && slick.activeBreakpoint <= 569) {
                slick.slickFilter(':not(.hide-on-mobile)');
                
            } else {
              slick.slickUnfilter();
            }
            isChanging = false;
        }
    }).slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 569,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
    });



    $('.js-h1-testimonials-carousel').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });


    $('.js-product-card-slider__slick').slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 568,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },{
            breakpoint: 1280,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        }],
    });
    $('.js-product-card-slider__slick').on('afterChange', function(){
        $(document).trigger('lazyrefresh');
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/components/sliders.js